import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PageHeader, Result, Button, Spin } from 'antd';
import { MyBreadcrumb, accessControls } from 'utils';
import TimeTrackerUserGroupForm from './form';

export default function TimeTrackerUserGroupUpdate() {
  const { id } = useParams();
  const history = useHistory();
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    accessControls
      .fetch()
      .then(setPermissions)
      .catch(() => setPermissions({}));
  }, []);

  if (permissions == null) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }
  if (!accessControls.can(permissions, 'TimeTrackerUserGroup.update:any')) {
    return (
      <div style={{ padding: 24 }}>
        <Result
          status="403"
          title="Access denied"
          subTitle="You do not have permission to edit user groups."
          extra={
            <Button type="primary" onClick={() => history.push('/')}>
              Go to Dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Time Tracker', path: '/time-tracker/tracker' },
          { label: 'User groups', path: '/time-tracker/user-groups' },
          { label: 'Edit', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Edit user group"
        subTitle="Update group name or members"
      >
        <TimeTrackerUserGroupForm id={id} />
      </PageHeader>
    </div>
  );
}
